import React from 'react';

// assets
import twitterIcon from '@assets/icons/media_twitter.svg';
import facebookIcon from '@assets/icons/media_facebook.svg';
import instaIcon from '@assets/icons/media_insta.svg';
import redditIcon from '@assets/icons/media_reddit.svg';
import linkedinIcon from '@assets/icons/media_linkedIN.svg';

// styles
import css from './styles.module.css';

interface SocialMediaLink {
  href: string;
  iconSrc: string;
}

interface FooterLink {
  href: string;
  label: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

const socialMediaLinks: SocialMediaLink[] = [
  {
    href: 'https://x.com/Turbopush_io',
    iconSrc: twitterIcon,
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61557191454002',
    iconSrc: facebookIcon,
  },
  {
    href: 'https://www.instagram.com/turbopush',
    iconSrc: instaIcon,
  },
  {
    href: 'https://www.reddit.com/user/TurboPush/',
    iconSrc: redditIcon,
  },
  {
    href: 'https://www.linkedin.com/company/turbopush',
    iconSrc: linkedinIcon,
  },
];

const footerSections: FooterSection[] = [
  {
    title: 'Product',
    links: [
      { href: '/blog', label: 'Blog' },
      { href: '/#pricing', label: 'Plans' },
    ],
  },
  {
    title: 'Company',
    links: [
      { href: '/about', label: 'About' },
      { href: '#', label: 'Support' },
      { href: '/feedback', label: 'Feedback form' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { href: '/privacy-policy', label: 'Privacy Policy' },
      { href: '/terms', label: 'Terms of Services' },
    ],
  },
];

const Footer: React.FC = () => {
  return (
    <footer className={css.infoFooterWrapper}>
      <div className={css.container}>
        <div className={css.wrapper}>
          <div className={css.mainContent}>
            <section className={css.linksGrid}>
              {footerSections.map((section) => (
                <div key={section.title} className={css.linkSection}>
                  <p className={css.sectionTitle}>{section.title}</p>
                  <div className={css.linksWrapper}>
                    {section.links.map((link) => (
                      <div key={link.label}>
                        <a href={link.href} className={css.link}>
                          {link.label}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </section>

            <div className={css.contactSection}>
              <a href="mailto:info@turbopush.io" className={css.emailLink}>
                info@turbopush.io
              </a>

              <div className={css.socialLinks}>
                {socialMediaLinks.map((social) => (
                  <a
                    key={social.href}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.socialLink}
                  >
                    <img
                      src={social.iconSrc}
                      alt=""
                      width={24}
                      height={24}
                      loading="lazy"
                      className={css.mediaIcon}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className={css.bottomSection}>
            <p className={css.text}>
              Turbopush OÜ is registered in Estonia (No. 16931864),
              <br />
              located at Harju maakond, Tallinn, Kesklinna linnaosa, Harju tn 3
              / Vana-Posti tn 2, 10146,
              <br />
              and is authorized as a private limited company.
            </p>
            <p className={css.text}>2024 ©TurboPush</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
